import(/* webpackMode: "eager", webpackExports: ["PageClientImpl"] */ "/app/app/rooms/[roomName]/PageClientImpl.tsx");
